import { Avatar } from "primereact/avatar";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Menubar } from "primereact/menubar"
import { MenuItem } from "primereact/menuitem";
import { SplitButton } from "primereact/splitbutton";
import AddPatientDialog from "../Utils/AddPatientDialog/addPatientDialog";
import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useConsultantSignout, useGetPatientMutation, useMarkEmergencyItemAsSeen } from "../hooks/useGetDataQuery";
import { useToastContext } from "../Lib/Contexts/toastContext";
import { OverlayPanel } from "primereact/overlaypanel";
import { Badge } from "primereact/badge";
import { Divider } from "primereact/divider";
import { Tooltip } from "primereact/tooltip";
import { formatNameAndSurname } from "../Utils/format";
import { Trans } from "react-i18next";

const GlobalLayoutMenubar = ({
    navigate,
    setPatientList,
    doctorName,
    lang,
    setLang,
    t,
    emergencyStopDataList,
    setEmergencyStopDataList
}: any) => {

    const location = useLocation();
    const { showToast } = useToastContext();

    const {
        mutate: consultantSignout,
        isSuccess: isSuccessConsultantSignout,
        isError: isErrorConsultantSignout,
        error: errorConsultantSignout,
        isPending: isPendingConsultantSignout
    } = useConsultantSignout();

    const {
        mutate: markEmergencyItemAsSeenMutation,
    } = useMarkEmergencyItemAsSeen();

    const {
        mutate: getPatient,
        data: patientData,
        isSuccess: isSuccessGetPatient,
    } = useGetPatientMutation();

    const [addPatientDialogVisible, setAddPatientDialogVisible] = useState(false);


    const countries = [
        { name: 'EN', code: 'GB', lang: "en" },
        { name: 'TR', code: 'TR', lang: 'tr' },
    ];

    const emergencyStopOverlayPanelRef = useRef<any>(null);
    const [emergencyStopUnseenCount, setEmergencyStopUnseenCount] = useState(0);
    const [hoveredEmergencyRowId, setHoveredEmergencyRowId] = useState<string | null>(null);
    const [selectedRow, setSelectedRow] = useState<any>(null);


    useEffect(() => {
        const count = emergencyStopDataList?.filter((item: any) => item.isRead === false).length || 0;
        setEmergencyStopUnseenCount(count);
    }, [emergencyStopDataList]);

    useEffect(() => {
        if (isSuccessGetPatient) {
            localStorage.setItem("patient", JSON.stringify({
                ...patientData.data,
                status: selectedRow.planStatus,
                planName: selectedRow.planName,
                firstName: formatNameAndSurname(patientData.data.firstName),
                lastName: formatNameAndSurname(patientData.data.lastName),
            }));

            emergencyStopOverlayPanelRef.current?.hide();
            if (location.pathname === "/mobithera/prescription") {
                window.location.reload();
            } else {
                navigate({ pathname: "/mobithera/prescription" });
            }
        }
    }, [isSuccessGetPatient, navigate]);

    const formatDateTime = (value: string) => {
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;

        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const hour = String(date.getHours()).padStart(2, "0");
        const minute = String(date.getMinutes()).padStart(2, "0");

        return `${day}.${month}.${year} - ${hour}:${minute}`;
    };

    const truncateText = (value: string, maxLength: number) => {
        if (!value) return "";
        if (value.length <= maxLength) return value;
        return `${value.slice(0, maxLength)}...`;
    };

    const markEmergencyItemAsSeen = (targetItem: any) => {
        setEmergencyStopDataList((prev: any[]) =>
            prev?.map((item: any) =>
                item.id === targetItem.id ? { ...item, isRead: true } : item
            ) || []
        );
        markEmergencyItemAsSeenMutation(targetItem.id);
    };

    const rowSelection = (item: any) => {
        setSelectedRow(item)
        getPatient(item.patientId);
    };


    const countryOptionTemplate = (option: any) => {
        return (
            <div className="flex align-items-center " >
                <img alt={option.name} src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`} className={`mr-2 flag flag-${option.code.toLowerCase()}`} style={{ width: '18px' }} />
                <div>{option.name}</div>
            </div>
        );
    };

    const selectedCountryTemplate = () => {
        return (
            <div className="dropdown-icon-container">
                <img src="/globe.svg" alt="globe" className="globe-icon" />
            </div>
        );
    };


    const itemsForMenu: MenuItem[] = [
        {
            label: t("home"),
            icon: <img src={window.location.pathname === "/mobithera/home" ? "/RedHome.svg" : "/home.svg"} alt="Home" style={{ marginRight: "5%" }} />,
            command: () => {
                navigate({ pathname: "/mobithera/home" });
            },
            className: window.location.pathname === "/mobithera/home" ? "p-focus" : "",

        },
        {
            label: t("patients"),
            icon: <img src={window.location.pathname === "/mobithera/patients" ? "/RedPatients.svg" : "/patients.svg"} alt="Home" style={{ marginRight: "5%" }} />,
            command: () => {
                navigate({ pathname: "/mobithera/patients" });
            },
            className: window.location.pathname === "/mobithera/patients" ? "p-focus ml-3" : "ml-3",
        },
        // {
        //     label: t("appointment"),
        //     icon: <img src={window.location.pathname === "/mobithera/appointment" ? "/RedAppointment.svg" : "/appointment.svg"} alt="Home" style={{ marginRight: "5%" }} />,

        //     command: () => {
        //         navigate({ pathname: "/mobithera/appointment" });
        //     },
        //     className: window.location.pathname === "/mobithera/appointment" ? "p-focus" : "",
        //     style: { color: "green" }
        // },
        {
            label: t("library"),
            icon: <img src={window.location.pathname === "/mobithera/library" ? "/RedPrescription.svg" : "/prescription.svg"} alt="Home" style={{ marginRight: "5%" }} />,
            command: () => {
                navigate({ pathname: "/mobithera/library" });
            },
            className: window.location.pathname === "/mobithera/library" ? "p-focus ml-3" : "ml-3",
        },
        {
            template: () => {
                return (
                    <Button
                        className="ml-3"
                        label={t("newPatient")}
                        icon={<img src="/addPatientIcon.svg" />}
                        style={{
                            backgroundColor: "#E3506B",
                            color: "white",
                            border: "#E3506B",
                            height: "3rem",
                            borderRadius: "10px",
                            width: "11rem",
                            fontWeight: "bold"
                        }}
                        onClick={() => setAddPatientDialogVisible(true)}
                    />
                );
            },
        },
    ];

    const signOut = useCallback(() => {
        const refreshToken = localStorage.getItem("refreshToken") || "";
        if (!refreshToken || refreshToken === "") return;
        consultantSignout(refreshToken);
    }, [consultantSignout]);

    useEffect(() => {
        let inactivityTimer: ReturnType<typeof setTimeout>;
        const INACTIVITY_LIMIT_MS = 5 * 60 * 1000;

        const resetTimer = () => {
            if (document.visibilityState === "hidden") {
                return;
            }
            clearTimeout(inactivityTimer);
            inactivityTimer = setTimeout(() => {
                signOut();
            }, INACTIVITY_LIMIT_MS);
        };

        const handleVisibilityChange = () => {
            if (document.visibilityState === "hidden") {
                clearTimeout(inactivityTimer);
            } else {
                resetTimer();
            }
        };

        resetTimer();

        window.addEventListener("mousemove", resetTimer);
        window.addEventListener("mousedown", resetTimer);
        window.addEventListener("keydown", resetTimer);
        window.addEventListener("scroll", resetTimer);
        window.addEventListener("touchstart", resetTimer);
        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            clearTimeout(inactivityTimer);
            window.removeEventListener("mousemove", resetTimer);
            window.removeEventListener("mousedown", resetTimer);
            window.removeEventListener("keydown", resetTimer);
            window.removeEventListener("scroll", resetTimer);
            window.removeEventListener("touchstart", resetTimer);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [signOut]);

    useEffect(() => {
        if (isSuccessConsultantSignout) {
            localStorage.removeItem("account");
            localStorage.removeItem("token");
            localStorage.removeItem("refreshToken");
            localStorage.removeItem("patient");
            navigate({ pathname: "/" });
        }
    }, [isSuccessConsultantSignout]);

    useEffect(() => {
        if (isErrorConsultantSignout) {
            showToast({
                severity: "error",
                summary: t("error"),
                detail: errorConsultantSignout?.message || t("signOutError"),
            });
        }
    }, [isErrorConsultantSignout]);

    const itemsForSplitButton: MenuItem[] = [
        {
            label: t("signOut"),
            command: () => signOut(),
            disabled: isPendingConsultantSignout,
        },
    ];

    const start = (
        <div
            onClick={() => {
                navigate({ pathname: "/mobithera/home" });
            }}
            style={{ cursor: "pointer", pointerEvents: "auto" }}
        >
            <img
                alt="logo"
                src="/logo.png"
                height="40"
                className="mr-2"
            />
        </div>
    );
    const end = (
        <div className="flex align-items-center gap-3">
            <div
                onClick={(event: any) => emergencyStopOverlayPanelRef.current?.toggle(event)}
                style={{ position: "relative", display: "inline-flex", cursor: "pointer" }}
            >
                <img src="/alarmIcon.svg" alt="alarm" />
                {emergencyStopUnseenCount > 0 && <Badge
                    value={emergencyStopUnseenCount}
                    style={{ position: "absolute", top: "-0.4rem", right: "-0.8rem", backgroundColor: "#E3506B", color: "#FFFFFF", borderRadius: "50%" }}
                />}
            </div>


            <Dropdown value={lang} onChange={(e) => setLang(e.value)} options={countries} optionLabel="name"
                valueTemplate={selectedCountryTemplate} itemTemplate={countryOptionTemplate}
                className='globalDropdown' appendTo="self" />

            <Avatar
                onClick={() => {
                    navigate({ pathname: "/mobithera/consultantProfile" });
                }}
                icon="pi pi-user"
                shape="circle"
                size="large"
            />
            <h4 style={{ color: "#FFFFFF" }}>{doctorName}</h4>

            <SplitButton
                model={itemsForSplitButton}
                severity="secondary"
                text
                buttonClassName="split-button-main"
                size="small"
                appendTo="self"
            />

            <OverlayPanel ref={emergencyStopOverlayPanelRef}>
                <p className="text-lg font-bold m-0" style={{ color: "#2D3967" }}>{t("emergencyStopRecords")}</p>
                <Divider />
                <Tooltip target=".emergency-plan-tooltip" position="bottom" />

                <div className="flex flex-column max-h-20rem overflow-y-auto w-30rem">
                    {emergencyStopDataList?.map((item: any) => {
                        const planProcedureText = `${item.planName || ""} | ${item.procedureName || ""}`;
                        const truncatedPlanProcedureText = truncateText(planProcedureText, 35);
                        const showPlanProcedureTooltip = planProcedureText.length > 35;
                        const rowId = String(item.id);
                        const isRowHovered = hoveredEmergencyRowId === rowId;

                        return (
                            <div key={item.id} className="flex flex-column ">
                                <div
                                    key={item.id}
                                    className="flex justify-content-between align-items-start gap-2"
                                    onClick={() => rowSelection(item)}
                                    onMouseEnter={() => setHoveredEmergencyRowId(rowId)}
                                    onMouseLeave={() => setHoveredEmergencyRowId(null)}
                                    style={{
                                        cursor: "pointer",
                                        borderRadius: "8px",
                                        padding: "0.5rem",
                                        transition: "background-color 0.2s ease",
                                        backgroundColor: isRowHovered ? "#EAF0FF" : "transparent"
                                    }}
                                >
                                    <div className="felx flex-column " >
                                        <p className=" font-bold m-0" style={{ color: "#2D3967" }}>{item.patientName ? item.patientName : t("anonymousPatient")} </p>
                                        <p
                                            className="text-sm m-0 emergency-plan-tooltip"
                                            style={{ color: "#2D3967" }}
                                            data-pr-tooltip={showPlanProcedureTooltip ? planProcedureText : ""}
                                        >
                                            {truncatedPlanProcedureText}
                                        </p>
                                        <br />
                                        <p className="text-sm m-0 w-15rem" style={{ color: "#2D3967" }}>
                                            <Trans i18nKey={item.emergencyReason} components={{ bold: <strong /> }} />
                                        </p>
                                    </div>

                                    <div className="flex flex-column align-items-end gap-1">
                                        <p className="text-sm m-0 mr-2" style={{ color: "#2D3967" }}>{formatDateTime(item.dateCreated)} </p>
                                        {!item.isRead && <Button
                                            label={t("markAsSeen")}
                                            style={{ color: "#2D3967", background: "transparent", border: "1px solid #2D3967", borderRadius: "10px", width: "10rem", height: "2rem" }}
                                            onClick={(event) => {
                                                event.stopPropagation();
                                                markEmergencyItemAsSeen(item);
                                            }}
                                        />}
                                    </div>

                                </div>
                                <Divider />
                            </div>
                        );
                    })}

                </div>

            </OverlayPanel>

        </div>
    );


    return (
        <>
            <Menubar className="w-full fixed" model={itemsForMenu} start={start} end={end}
                style={{
                    backgroundColor: "#2D3967",
                    border: "none",
                    borderRadius: "0",
                    paddingTop: "1.5rem",
                    paddingLeft: "1.5rem",
                    paddingRight: "1.5rem",
                    zIndex: 1000

                }} />
            <AddPatientDialog
                t={t}
                setPatientList={setPatientList}
                addPatientDialogVisible={addPatientDialogVisible}
                setAddPatientDialogVisible={setAddPatientDialogVisible}
            />
        </>

    )
}

export default GlobalLayoutMenubar